import { ProductDetailsPage } from 'apps/commerce/types.ts'

export interface Props {
	page: ProductDetailsPage | null
}

export default function Avaliacoes({ page }: Props) {
	if (!page) {
		console.warn('[Avaliacoes] Nenhuma página de produto encontrada')
		return <></>
	}

	const categoryList = page.product.category?.split('>')
	const category = categoryList?.[categoryList.length - 1]

	return (
		<>
			<div class='container-center'>
				<div
					class='trustvox-container'
					id='trustvox-reviews'
					style='clear: both; padding: 10px'
				>
					<div id='_trustvox_widget'></div>
				</div>
			</div>

			<script
				loading={'lazy'}
				src='//ajax.googleapis.com/ajax/libs/jquery/1.8/jquery.min.js'
			>
			</script>

			<script
				loading={'lazy'}
				type='text/javascript'
				dangerouslySetInnerHTML={{
					__html: `
						console.log('[Trustvox Inline] Executando configuração do Trustvox');

						var _trustvox_shelf_rate = _trustvox_shelf_rate || [];
						_trustvox_shelf_rate.push(["_storeId", "121490"]);
						_trustvox_shelf_rate.push(["_productContainer", "body"]);
						_trustvox_shelf_rate.push(["_watchSubtree", true]);
					`,
				}}
			/>

			<script
				loading={'lazy'}
				type='text/javascript'
				async={true}
				src='//rate.trustvox.com.br/widget.js'
			>
			</script>

			<script
				loading={'lazy'}
				type='text/javascript'
				dangerouslySetInnerHTML={{
					__html: `
						$(document).ready(function () {
							console.log('[Trustvox Inline] Produto ID:', ${page.product.inProductGroupWithID});
							console.log('[Trustvox Inline] Produto Nome:', "${page.product.name}");
							console.log('[Trustvox Inline] Produto Imagem:', "${
						page.product.image?.[0].url
					}");
							console.log('[Trustvox Inline] Categoria:', "${category}");

							window._trustvox = [];
							_trustvox.push(["_storeId", "121490"]);
							_trustvox.push(["_productId", ${page.product.inProductGroupWithID}]);
							_trustvox.push(["_productName", "${page.product.name}"]);
							_trustvox.push(["_productPhotos", "${page.product.image?.[0].url}"]);

							var tags = [];
							tags.push("Categoria/" + "${category}");
							_trustvox.push(["_tags", tags]);

							console.log('[Trustvox Inline] Tags configuradas:', tags);

							$(".trustvox-fluid-jump").on("click", function (event) {
								event.preventDefault();
								var offset = $($(this).attr("href")).offset().top;
								$("html, body").animate({ scrollTop: offset }, 500);
							});
						});
					`,
				}}
			/>
		</>
	)
}
